import { Injectable, OnDestroy } from '@angular/core';
import { Subscription, BehaviorSubject } from 'rxjs';

@Injectable()

export class NavbarService implements OnDestroy {
  subscriptions: Subscription[] = [];
  showConfirmation$ = new BehaviorSubject<boolean>(null);
  helpopened$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  ngOnDestroy() {
    this.subscriptions.forEach(s => {
      s.unsubscribe();
    });
  }
}
